import * as i0 from "@angular/core";
export class GetSharingTooltipMessagePipeModule {
}
GetSharingTooltipMessagePipeModule.ɵfac = function GetSharingTooltipMessagePipeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GetSharingTooltipMessagePipeModule)(); };
GetSharingTooltipMessagePipeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GetSharingTooltipMessagePipeModule });
GetSharingTooltipMessagePipeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
